import './index.less';
import Icon from '@/components/iconfont/Icon.jsx';
import { useEffect, useRef, useState } from 'react';

export default function CustomPlayerBar({
  duration,
  time,
  handlePlay,
  handlePause,
  handleChangeTime,
  isPaused = true,
}) {
  const container = useRef(null);
  const [percent, setPercent] = useState(0);
  useEffect(() => {
    if (duration) {
      const percent = time / duration;
      setPercent(percent);
      if (percent >= 1) {
        setIsPlaying(false);
      }
    }
  }, [time, duration]);

  function calcPercent(pointerEvent) {
    const { offsetX, offsetY, layerX } = pointerEvent;
    const pointerX = !offsetX && !offsetY && layerX ? layerX : offsetX;
    const { clientWidth } = container.current;
    return pointerX / clientWidth;
  }

  useEffect(() => {
    const barEl = container.current;

    function handlePointerChange(e) {
      const percent = Math.min(calcPercent(e), 1);
      setPercent(percent);
      handleChangeTime && handleChangeTime(percent * duration);
    }

    barEl.onpointerdown = (e) => {
      barEl.setPointerCapture(e.pointerId);
      handlePause && handlePause();
      setIsPlaying(false);
      handlePointerChange(e);

      barEl.onpointermove = handlePointerChange;

      barEl.onpointerup = (e) => {
        handlePointerChange(e);
        barEl.onpointermove = null;
        barEl.onpointerup = null;
      };
    };
  }, [duration]);

  const [isPlaying, setIsPlaying] = useState(false);
  function handleTogglePlay() {
    if (isPlaying) {
      setIsPlaying(false);
      handlePause && handlePause();
    } else {
      setIsPlaying(true);
      handlePlay && handlePlay();
    }
  }

  useEffect(() => {
    setIsPlaying(!isPaused);
  }, [isPaused]);

  return (
    <div className="custom-player-bar">
      <button className="btn" onClick={handleTogglePlay}>
        {isPlaying ? <Icon name="icon-pause"></Icon> : <Icon name="icon-play"></Icon>}
      </button>

      <div ref={container} className="progress-container">
        <div className="bar" style={{ width: percent * 100 + '%' }}></div>
      </div>
    </div>
  );
}
